/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({ inboxId, agentList, autoAssignmentSettings = {} }) {
    return axios.patch(this.url, {
      inbox_id: inboxId,
      user_ids: agentList,
      auto_assignment_settings: autoAssignmentSettings,
    });
  }

  updateAutoAssignment({ inboxId, userId, enabled }) {
    return axios.patch(`${this.url}/${inboxId}/auto_assignment`, {
      user_id: userId,
      auto_assignment_enabled: enabled,
    });
  }
}

export default new InboxMembers();
